import * as React from 'react';

import { cn } from '@/lib/utils';
import type { ValidationState } from '@/theme/size-tokens';
import {
  validationBorderClasses,
  validationRingClasses,
} from '@/theme/size-tokens';

type TextareaProps = React.ComponentProps<'textarea'> & {
  validationState?: ValidationState;
};

function Textarea({
  className,
  validationState = 'neutral',
  ...props
}: TextareaProps) {
  return (
    <textarea
      data-slot="textarea"
      aria-invalid={validationState === 'error'}
      className={cn(
        'bg-transparent text-foreground placeholder:text-muted-foreground flex min-h-25 w-full rounded-lg border px-4 py-3 text-base shadow-md transition-all duration-200 outline-none focus:ring-2 focus:ring-offset-0 focus:shadow-lg disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-muted/50 resize-y sm:min-h-20 sm:px-3 sm:py-2 sm:text-sm',
        validationBorderClasses[validationState],
        validationRingClasses[validationState],
        className
      )}
      {...props}
    />
  );
}

export { Textarea };
export type { TextareaProps };
